const override = false;
const config = {
    development: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '35.222.170.66',
        FUNNEL_SUB_DOMAIN_URL: 'flash-funnel-staging.msgsndr.com',
        MEMBERSHIP_ROOT_DOMAIN_IP_ADDRESS: '35.190.31.12',
        MEMBERSHIP_SUB_DOMAIN_URL: 'staging.preview.memberships.msgsndr.com',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'staging.msgsndr.com',
        WHITE_LABELED_SUB_DOMAIN_URL: 'staging.msgsndr.com',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'staging.link.msgsndr.com',
        DOMAIN_CONNECT_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/email-isv',
        mode: 'development',
    },
    staging: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '35.222.170.66',
        FUNNEL_SUB_DOMAIN_URL: 'flash-funnel-staging.msgsndr.com',
        MEMBERSHIP_ROOT_DOMAIN_IP_ADDRESS: '35.190.31.12',
        MEMBERSHIP_SUB_DOMAIN_URL: 'staging.preview.memberships.msgsndr.com',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'staging.msgsndr.com',
        WHITE_LABELED_SUB_DOMAIN_URL: 'staging.msgsndr.com',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'staging.link.msgsndr.com',
        DOMAIN_CONNECT_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/email-isv',
        mode: 'staging',
    },
    beta: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '34.68.234.4',
        FUNNEL_SUB_DOMAIN_URL: 'flash.funnels.msgsndr.com',
        MEMBERSHIP_ROOT_DOMAIN_IP_ADDRESS: '34.72.209.232',
        MEMBERSHIP_SUB_DOMAIN_URL: 'preview.memberships.msgsndr.com',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'link.msgsndr.com',
        WHITE_LABELED_SUB_DOMAIN_URL: 'link.msgsndr.com',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'link.msgsndr.com',
        DOMAIN_CONNECT_SERVICE_URL: 'https://services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://services.leadconnectorhq.com/email-isv',
        mode: 'beta',
    },
    production: {
        FUNNEL_ROOT_DOMAIN_IP_ADDRESS: '34.68.234.4',
        FUNNEL_SUB_DOMAIN_URL: 'flash.funnels.msgsndr.com',
        MEMBERSHIP_ROOT_DOMAIN_IP_ADDRESS: '34.72.209.232',
        MEMBERSHIP_SUB_DOMAIN_URL: 'preview.memberships.msgsndr.com',
        WORDPRESS_ROOT_DOMAIN_IP_ADDRESS: '104.18.185.50',
        API_DOMAIN_SUB_DOMAIN_URL: 'link.msgsndr.com',
        WHITE_LABELED_SUB_DOMAIN_URL: 'link.msgsndr.com',
        DOMAIN_BRANDED_SUB_DOMAIN_URL: 'link.msgsndr.com',
        DOMAIN_CONNECT_SERVICE_URL: 'https://services.leadconnectorhq.com/domain-connect',
        EMAIL_ISV_SERVICE_URL: 'https://services.leadconnectorhq.com/email-isv',
        mode: 'production',
    },
};
if (override) {
    // do overrides here
    // config.development.DOMAIN_CONNECT_SERVICE_URL =
    //   'http://localhost:6050/domain-connect'
}
export default config[process.env.mode];
